export default "__VITE_ASSET__DmIKRmyT__"